<template lang="pug">
    multiselect-form(
        ref="tagSelector"
        :value="value",
        name="tagSelector",
        :options="tagList",
        :max="tagLimit",
        :placeholder="`${trans('tag.type_to_search_or_create_tag')}`",
        :item-placeholder="`${trans('tag.add_this_as_new_category')}`",
        @create="submit",
        @add-item="addItem",
        @show-form="onShowForm",
        @hide-form="onHideForm",
        @input="onInput",
        :title="`${trans('tag.title')}`",
        :loader-name="`${trans('tag.create_tag')}`",
        :form-title="`${trans('tag.create_new_tag')}`",
        :disabled="disabled"
    )
        template(slot="body")
            form(id="tagForm")
                div.row
                    div.col-xs-12
                        div.md-form-group
                            input.md-input(
                                type="text",
                                :value="tag.name",
                                ref="tagName",
                                @input="updateTag('name', $event.target.value)",
                                :disabled="onCreateLoading",
                                required
                            )
                            label Name

                div.row
                    div.col-xs-12
                        div.md-form-group
                            input.md-input(
                                type="text",
                                :value="tag.description",
                                @input="updateTag('description', $event.target.value)",
                                :disabled="onCreateLoading",
                            )
                            label Description  

                div.row
                    div.col-xs-12
                        multiselect(
                            label="name",
                            track-by="id",
                            :placeholder="`${trans('tag.select_parent_tag')}`",
                            :options="tagList",
                            :close-on-select="true",
                            :max-height="170",
                            v-model="parentTag"
                        )

                div.row.m-t-md
                    div.col-xs-12
                        div.form-group
                            label.md-switch
                                input.has-value(
                                    name="hidden_tag",
                                    :disabled="onCreateLoading",
                                    type="checkbox",
                                    v-model="hidden_tag"
                                )
                                i.indigo
                                | {{ trans('tag.hide_tag') }}

                div.row
                    div.col-xs-12
                        div.form-group
                            label.md-switch
                                input.has-value(
                                    :disabled="onCreateLoading",
                                    type="checkbox",
                                    name="hidden_products",
                                    v-model="hidden_products"
                                )
                                i.indigo
                                | Hide Products
</template>

<script>
import multiselectForm from './multiselect-form.vue';
import { mapGetters, mapActions } from 'vuex';
import Unleash from '@js/plugins/unleash';

export default {
    components: { multiselectForm },

    props: {
        value: {
            type: Array,
            required: true,
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            hidden_tag: false,
            hidden_products: false,
            parentTag: null,
            // PS-10978: one tag per product while the upgrade flag is on
            tagLimit: Unleash.hasFeature('sentinel_laravel_upgrade')
                ? 1
                : false,
        };
    },

    computed: {
        ...mapGetters('tag', ['tagList', 'tag']),

        onCreateLoading() {
            return this.onLoading('create tag');
        },
    },

    watch: {
        hidden_tag(newVal) {
            this.updateTag('hidden_tag', newVal);
        },

        hidden_products(newVal) {
            this.updateTag('hidden_products', newVal);
        },

        parentTag(newVal) {
            let parentId = !_.isNull(newVal) ? newVal.id : null;
            this.updateTag('parent_id', parentId);
        },
    },

    mounted() {
        this.registerEvent();
    },

    methods: {
        ...mapActions('tag', [
            'getTagList',
            'setTagAttribute',
            'createTag',
            'addTag',
            'resetTag',
        ]),

        submit() {
            if (!this.validateForm('tagForm')) return;

            this.startLoading('create tag');

            this.createTag()
                .then(res => {
                    let item = res.data.data;
                    this.$emit('item-created', item);
                })
                .catch(err => {
                    this.showApiError(err);
                    this.endLoading('create tag');
                });
        },

        updateTag(attribute, value) {
            this.setTagAttribute({ attribute, value });
        },

        addItem(item) {
            this.updateTag('name', item);
        },

        focusOnForm() {
            this.$nextTick(() => {
                this.$refs.tagName.focus();
            });
        },

        onShowForm() {
            this.focusOnForm();
        },

        onHideForm() {
            this.resetValue();
            this.resetTag();
        },

        showOptionList(select = null) {
            setTimeout(() => {
                this.$refs.tag_selector.activate();
            }, 100);
        },

        resetValue() {
            this.hidden_products = false;
            this.hidden_tag = false;
            this.parentTag = null;
        },

        registerEvent() {
            this.$on('item-created', item => {
                this.addTag(item);
                this.$refs.tagSelector.$emit('item-created', item);
            });
        },

        onInput(value) {
            this.$emit('input', value);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/item/tag-selector.vue